import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Row,
  Col,
  Card,
  Select,
  DatePicker,
  Modal,
  Form,
  Empty,
  message,
  Checkbox,
  Divider,
  Button,
  Skeleton,
  Avatar
} from "antd";
import { IconButton } from "../components/Buttons/buttons";
import {
  BookFilled,
  DownOutlined,
  EyeFilled,
  MailOutlined,
  FileOutlined,
  SearchOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from "moment";

import * as ManufactureRequest from "../services/ManufactureRequest";
import * as InspectionServices from "../services/InspectionReports";
import * as getClientdropService from "../services/getClientdrop";
import * as PdfServices from "../services/GetPdf";
import CommentSection from "../components/CommentSection";

const { Option } = Select;

function AllManufacturerClaimTable(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  // ── 1) Pagination & data state ────────────────────────────────────────────
  const [data, setData] = useState([]);       // Holds the current page’s rows
  const [total, setTotal] = useState(0);      // Total row count from server
  const [page, setPage] = useState(1);        // Current page
  const [pageSize, setPageSize] = useState(10);// Rows per page

  // ── 2) Other UI & filter state ────────────────────────────────────────────
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState([]);             // For button‐loading states
  const [claimAnalystDropdown, setClaimAnalystDropdown] = useState([]);
  const [isActive, setIsActive] = useState(false);          // Show/hide filter panel
  const [statusModal, setStatusModal] = useState(false);    // Show/hide “Change Status” modal
  const [statusValues, setStatusValues] = useState({});     // Data for the status modal
  const [searchedText, setSearchedText] = useState("");     // For the search input (client‐side on–current page)
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
  const [checkedins, setCheckedins] = useState(true);       // Checkbox in modal
  const [checkedass, setCheckedass] = useState(true);       // Checkbox in modal
  const [commentData, setCommentData] = useState([]);       // Comments for the status modal
  const [remainingInspections, setRemainingInspections] = useState([]);
  const [filter, setFilter] = useState('all');


  useEffect(() => {
    fetchData(page, pageSize);
    fetchClaimAnalystData();
    fetchRemainingInspections();
    window.scrollTo(0, 0);
  }, [page, pageSize, props.activeKey,searchedText, filterStartDate, filterEndDate,filter]);


  const fetchData = (currentPage, currentPageSize) => {
    const isArchivedTab = props.activeKey === "6"; 
    const statusForApi = filter !== "all" ? filter : props.activeKey === "6" ? "Archived" : "";
    const filters = {
      page: currentPage,
      pageSize: currentPageSize,
      search: searchedText?.trim() || "",
      date_from: filterStartDate || "",
      date_to: filterEndDate || "",
      status: statusForApi,
      exclude_archived: !isArchivedTab && filter === "all"
    };

    setLoading(true);

    dispatch(ManufactureRequest.getInspectionManufactureData(filters))
      .then((res) => {
        setData(res?.data || []);
        setTotal(res?.pagination?.total_items || 0);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        message.error("Failed to load data. Please try again later.");
        console.error("Error loading inspections", err);
      });
  };

  const fetchRemainingInspections = () => {
    setLoading(true);
    dispatch(ManufactureRequest.getRemainingInspectionData())
      .then((res) => {
        setRemainingInspections(res);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching remaining inspections:", err);
        setLoading(false);
      });
  };

  const fetchClaimAnalystData = () => {
    dispatch(getClientdropService.getClaimanalystDrop())
      .then((res) => {
        setClaimAnalystDropdown(res);
      })
      .catch((err) => {
        console.error("Error fetching claim analyst list:", err);
      });
  };

  // ── 7) Client‐side “Status” filter on the current page ────────────────────
  const handleStatusFilter = (value) => {
    setFilter(value)
    setPage(1)
  };

  // ── 8) Date‐range filter on current page ───────────────────────────────────
    const onChangeStartDate = (date, dateString) => {
      if (!dateString) {
        setFilterStartDate("");
        return;
      }
      const start = moment(dateString).format("MM-DD-YYYY");
      setFilterStartDate(start);
      setPage(1)
    };

    const onChangeEndDate = (date, dateString) => {
      if (!dateString) {
        setFilterEndDate("");
        return;
      }
      const end = moment(dateString).format("MM-DD-YYYY");
      setFilterEndDate(end);
      setPage(1)
    };

  // ── 9) Open “Change Status” modal ─────────────────────────────────────────
  const openStatusModal = (statusValues) => {
    console.warn({statusValues});
    setStatusValues(statusValues);
    getCommentData(statusValues.req_id);
    form.setFieldsValue({
      claimanalyst_drop: statusValues.client_name,
      status_change: statusValues.status,
    });
    setStatusModal(true);
  };

  // ── 10) Get comment history for a request ─────────────────────────────────
  const getCommentData = (req_id) => {
    setLoading(true);
    console.warn(req_id);
    dispatch(InspectionServices.getComments(req_id))
      .then((res) => {
        setCommentData(res);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching comments:", err);
        setLoading(false);
      });
  };

  // ── 11) Submit “Change Status” form ──────────────────────────────────────
 const onFinish = (values) => {
  const previousStatus = statusValues.status;
  const newStatus = values.status_change;

  // Check if status has changed
  const isStatusChanged = previousStatus !== newStatus;

  // Check if comment is added
  const hasComment = values.comment_status && values.comment_status.trim() !== "";

  // If no status change and no comment, do nothing
  if (!isStatusChanged && !hasComment) {
    message.info("No changes detected.");
    return;
  }
  if (!isStatusChanged) {
  delete values.status_change; // Optional: exclude from payload
  }
  setLoadings([true]);
  values.pId = statusValues.req_id;
  values.client_name = statusValues.client_name;
  values.client_email = statusValues.client_email;
  values.self_name = statusValues.self_name;
  values.self_email = statusValues.self_email;
  values.inspector_id = statusValues.inspector_id;
  values.notify_ins = checkedins ? "yes" : "";
  values.notify_assignee = checkedass ? "yes" : "";

  // Optionally, split comment-only and full update logic
  dispatch(InspectionServices.updateStatusClaim(values))
    .then((res) => {
      message.success(isStatusChanged ? "Status updated!" : "Comment added!");
      setStatusModal(false);
      fetchData(page, pageSize);
      form.resetFields();
      setLoadings([false]);
    })
    .catch((err) => {
      console.error("Failed to update status:", err);
      const errorMessage =
        err?.response?.data?.message || "Failed to update status. Please try again later.";
      message.error(errorMessage);
      setLoadings([false]);
    });
};


  const onFinishFailed = (errorInfo) => {
    console.log("Status form validation failed:", errorInfo);
  };

  const handleCancel = () => {
    setStatusModal(false);
  };

  // ── 12) Simple button‐loading state for modals ─────────────────────────────
  const enterLoading = (index) => {
    setLoadings((prev) => {
      const arr = [...prev];
      arr[index] = true;
      return arr;
    });
    setTimeout(() => {
      setLoadings((prev) => {
        const arr = [...prev];
        arr[index] = false;
        return arr;
      });
    }, 6000);
  };

  // ── 13) Download PDF attachments ───────────────────────────────────────────
  const getPdfAttachments = (report_id) => {
    const values = { report_id };
    dispatch(PdfServices.getPdfAttachments(values))
      .then((res) => {
        window.open(res, "download");
      })
      .catch((err) => {
        console.error("Error downloading PDF:", err);
      });
  };

  // ── 14) “View Report” logic (unchanged) ───────────────────────────────────
  const viewReport = (record) => {
    enterLoading(0);
    const action = record.action;
    const {
      category,
      report_id,
      invoice_id,
      ins_status,
      report_generated,
      add_attachments,
      request_type,
    } = action;

    if (category === "Carpet -Basic") {
      navigate("/single-carpet-basic/?report_id=" + report_id);
    } else if (category === "Carpet") {
      navigate("/single-carpet-detailed/?report_id=" + report_id);
    } else if (category === "Hard Surface -Basic") {
      navigate("/single-hardwood-basic/?report_id=" + report_id);
    } else if (category === "LVT") {
      navigate("/single-lvt/?report_id=" + report_id);
    } else if (category === "Hardwood") {
      navigate("/single-hardwood-detailed/?report_id=" + report_id);
    } else if (category === "Tile") {
      navigate("/single-tile-report/?report_id=" + report_id);
    } else if (category === "Laminate") {
      navigate("/single-Laminate/?report_id=" + report_id);
    } else if (category === "Field Service") {
      const type = action.form_type || 'field_service';
      if (type === 'out_of_warranty') {
        navigate("/analyst-fs-process-form/?report_id=" + (action.analystReportId || report_id));
      } else {
        navigate("/field-service-resolution-form/?report_id=" + report_id);
      }
    } else {
      navigate("/single-quick-report/?report_id=" + report_id);
    }
  };

  // ── 15) Define table columns ───────────────────────────────────────────────
  const columns = [
    {
      title: "S. No.",
      dataIndex: "S_No.",
      key: "index",
      render: (_value, _item, idx) => <>{(page - 1) * pageSize + idx + 1}</>,
    },
    {
      title: "Claim #",
      dataIndex: "claim_number",
      key: "claim_number",
      filteredValue: [searchedText],
      onFilter: (value, record) => {
        return (
          String(record.claim_number).toLowerCase().includes(value.toLowerCase()) ||
          String(record.ins_name).toLowerCase().includes(value.toLowerCase()) ||
          String(record.ins_date).toLowerCase().includes(value.toLowerCase()) ||
          String(record.date).toLowerCase().includes(value.toLowerCase()) ||
          String(record.rem_day).toLowerCase().includes(value.toLowerCase()) ||
          String(record.assigned_to).toLowerCase().includes(value.toLowerCase()) ||
          String(record.status_hidden).toLowerCase().includes(value.toLowerCase())
        );
      },
      sorter: (a, b) => (a.claim_number || "").localeCompare(b.claim_number || ""),
    },
    {
      title: "Inspector Name",
      dataIndex: "ins_name",
      key: "Inspector_name",
      sorter: (a, b) => (a.ins_name || "").localeCompare(b.ins_name || ""),
    },
    {
      title: "Inspection Date",
      dataIndex: "ins_date",
      key: "ins_date",
      sorter: (a, b) => (a.ins_date || "").localeCompare(b.ins_date || ""),
    },
    {
      title: "Request Date",
      dataIndex: "date",
      key: "request_date",
      sorter: (a, b) => (a.date || "").localeCompare(b.date || ""),
    },
    {
      title: "Requested",
      dataIndex: "rem_day",
      key: "Requested",
      sorter: (a, b) => (a.rem_day || "").length - (b.rem_day || "").length,
    },
    {
      title: "Assigned To",
      dataIndex: "assigned_to",
      key: "Assigned_to",
      sorter: (a, b) => (a.assigned_to || "").length - (b.assigned_to || "").length,
    },
    {
      title: "Status",
      dataIndex: "status_hidden",
      key: "status_hidden",
      sorter: (a, b) =>
        (a.status_hidden || "").localeCompare(b.status_hidden || ""),
      render: (_text, record) => (
        <Button className="statusTags" onClick={() => openStatusModal(record.status)}>
          {record.status_hidden}
        </Button>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_i, record) => (
        <div className="actionBtn">
          <IconButton
            icon={<EyeFilled />}
            type="primary"
            tooltip="View"
            text="View"
            handleClick={() =>
              navigate("/single-request/?req_id=" + record.action.req_id)
            }
          />
          {record.action.report_generated === "YES" &&
          record.action.ins_status === "Complete" ? (
            <>
              <IconButton
                icon={<FileOutlined />}
                type="primary"
                tooltip="View Report"
                text="Report"
                handleClick={() => viewReport(record)}
              />
              {record.action.add_attachments === "Yes" && (
                <IconButton
                  icon={<PictureOutlined />}
                  type="primary"
                  tooltip="Photos"
                  text="Photos"
                  handleClick={() =>
                    getPdfAttachments(record.action.report_id)
                  }
                />
              )}
              {record.action.invoice_generated === "YES" && (
                <IconButton
                  icon={<BookFilled />}
                  type="primary"
                  tooltip="Invoice"
                  text="Invoice"
                  handleClick={() =>
                    navigate(
                      "/report-invoice/?invoice_id=" +
                        record.action.invoice_id
                    )
                  }
                />
              )}
              <IconButton
                icon={<MailOutlined />}
                type="primary"
                tooltip="Send"
                text="Send"
                handleClick={() =>
                  navigate("/send-email/?req_id=" + record.action.req_id)
                }
              />
            </>
          ) : record.action.request_type === "Flooring dealer" ? (
            <IconButton
              icon={<MailOutlined />}
              type="primary"
              tooltip="Send Decision"
              text="Send Decision"
              handleClick={() =>
                navigate(
                  "/send-decision/?req_id=" + record.action.req_id
                )
              }
            />
          ) : null}
        </div>
      ),
    },
  ];

  // ── 16) Render ─────────────────────────────────────────────────────────────
  return (
    <div>
      <div className="tableWrapper">
        <div className="filterWrap">
          <Row gutter={16} justify="space-between">
            <Col md={6} xs={24}>
              <div className="searchWrapper">
                <Input
                  className="formControl"
                  prefix={<SearchOutlined />}
                  allowClear
                  placeholder="Search..."
                  onSearch={(value) => setSearchedText(value)}
                  onChange={(e) => {
                    setSearchedText(e.target.value)
                    setPage(1)
                  }}
                />
              </div>
            </Col>
            <Col md={4} xs={24}>
              <div className="filterDropdown text-end">
                <button
                  type="button"
                  className={isActive ? "btnActive filterBtn" : "filterBtn"}
                  onClick={() => setIsActive((cur) => !cur)}
                >
                  Filter <DownOutlined className="dropIcon" />
                </button>
              </div>
            </Col>
            <Col md={24}>
              {isActive && (
                <div className="filterSection">
                  <Card className="filterCard">
                    <Row gutter={16} justify="center">
                      <Col span={4}>
                        <div className="formGroup">
                          <Input
                            placeholder="Claim Number"
                            className="formControl"
                            allowClear
                            onSearch={(value) => setSearchedText(value)}
                            onChange={(e) =>{
                              setSearchedText(e.target.value)
                              setPage(1)
                            }
                               
                              }
                          />
                        </div>
                      </Col>
                      <Col span={4}>
                        <div className="formGroup">
                          <Select value={filter} onChange={handleStatusFilter}>
                            <Option value="all">All</Option>
                            <Option value="pending">Pending</Option>
                            <Option value="Completed">Complete</Option>
                            <Option value="Archived">Archived</Option>
                            <Option value="Cancelled">Cancelled</Option>
                            <Option value="More info requested">More info requested</Option>
                          </Select>
                        </div>
                      </Col>
                      <Col span={4}>
                        <div className="formGroup">
                          <DatePicker
                            name="start_date"
                            onChange={onChangeStartDate}
                            placeholder="Date From"
                            format="MM/DD/YYYY"
                          />
                        </div>
                      </Col>
                      <Col span={4}>
                        <div className="formGroup">
                          <DatePicker
                            name="end_date"
                            onChange={onChangeEndDate}
                            placeholder="Date To"
                            format="MM/DD/YYYY"
                          />
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </div>
              )}
            </Col>
          </Row>
        </div>

        <Card className="reportCard">
          <Row gutter={16}>
            <Col>
              <div className="d-flex align-Items-center">
                <p className="tableHeaderText">Remaining Inspections: </p>
                <span>
                  <p className="m-2">
                    {remainingInspections?.remaining}/{remainingInspections?.total}
                  </p>
                </span>
              </div>
            </Col>
          </Row>
          <Divider />

          <Table
            bordered
            className="inspectionDataTable customInspectionTable"
            tableLayout="auto"
            scroll={{ x: 1000 }}
            columns={columns}
            dataSource={data}
            rowKey={(record) => record.req_id}
            loading={loading}
            pagination={{
              current: page,
              pageSize: pageSize,
              total: total,  
              showSizeChanger: true,
              pageSizeOptions: ["5", "10", "20", "50"],
              onChange: (newPage, newSize) => {
                setPage(newPage);
                setPageSize(newSize);
              },
              position: ["bottomCenter"],
            }}
            locale={{
              emptyText: loading
                ? columns.map((_, i) => (
                    <Skeleton.Input
                      key={i}
                      height={50}
                      style={{ marginTop: "2px", height: "48px", padding: "0px" }}
                      block
                      active
                    />
                  ))
                : <Empty />,
            }}
          />

          {/* Status Modal */}
          <Modal
            title="Change Status"
            centered
            open={statusModal}
            className="inspectionCategoryModal industryModal"
            width={680}
            footer={[
              <Button
                key="submit"
                htmlType="submit"
                className="submitBtn"
                onClick={form.submit}
                loading={loadings[0]}
              >
                Save Changes
              </Button>,
              <Button key="cancel" className="submitBtn" onClick={handleCancel}>
                Cancel
              </Button>,
            ]}
            onCancel={handleCancel}
          >
            <div className="modalContent">
              <Form
                form={form}
                name="statusForm"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                layout="vertical"
              >
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item label="Claim Analyst" name="claimanalyst_drop">
                      <Select defaultValue="Select Claim Analyst">
                        {claimAnalystDropdown.length > 0 ? (
                          claimAnalystDropdown.map((option, idx) => (
                            <Option value={option.id} key={idx}>
                              {option.name}
                            </Option>
                          ))
                        ) : (
                          <Option value="No data">
                            <Empty />
                          </Option>
                        )}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item label="Status" name="status_change">
                      <Select defaultValue="Change Status">
                        <Option value="RFQ_accepted">RFQ Accept</Option>
                        <Option value="RFQ_declined">RFQ Decline</Option>
                        <Option value="Pending">Pending</Option>
                        <Option value="Completed">Completed</Option>
                        <Option value="Archived">Archive</Option>
                        <Option value="Delete">Delete</Option>
                        <Option value="Cancelled">Cancelled</Option>
                        <Option value="More info requested">
                          More info requested
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item name="notify_ins">
                      <Checkbox
                        onChange={(e) => setCheckedins(e.target.checked)}
                        checked={checkedins}
                      >
                        Notify Inspector
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item name="notify_assignee">
                      <Checkbox
                        onChange={(e) => setCheckedass(e.target.checked)}
                        checked={checkedass}
                      >
                        Notify Claim analyst
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>

                <CommentSection
                  loading={loading}
                  comments={commentData?.data}
                  newCommentFieldName="comment_status"
                />
              </Form>
            </div>
          </Modal>
        </Card>
      </div>
    </div>
  );
}

export default AllManufacturerClaimTable;